<template>
  <div class="appRepairApplication">
    <van-nav-bar title="报修申请" left-text="返回" left-arrow @click-left="onClickLeft" />
    <div class="content">
      <div class="van-title">
        <img src="../../assets/h5/wbpz.png" class="img1" alt="">
        <div class="van-title_text">报修申请</div>
      </div>
      <div class="form">
        <van-form validate-first @failed="onFailed">
          <div class="title-desc"><span style="color:#ff0000">*</span>标题:</div>
          <input-pattern :check-list="checkList" :index="5"></input-pattern>
          <div class="title-desc"><span style="color:#ff0000">*</span>维修点:</div>
          <!-- inputPattern -->
          <input-pattern :check-list="checkList" class="addressText" :disabled="true" :index="7"></input-pattern>
          <!-- <van-button type="primary" class="btn" @click="checkProject">检索</van-button> -->
          <div class="title-desc">
            <!-- <span style="color:#ff0000">*</span> -->
            报修地点:</div>
          <van-field v-model="checkList[2].value" :disabled="true" class="addressText" placeholder="根据项目绑定" />

          <!-- <input-pattern :check-list="checkList" class="addressText" :index="2" :disabled="true" @click="showPicker=true"></input-pattern> -->
          <!-- <van-popup v-model="showPicker" position="bottom">
            <van-picker ref="vanPickers" show-toolbar title="地区选择" :columns="columns" @cancel="cancelPicker" @confirm="confirmPicker" />
          </van-popup> -->
          <van-popup v-model="projectShow" position="bottom">
            <van-picker show-toolbar :columns="projectNeedName" @confirm="projectConfirm" @cancel="projectShow=false" /></van-popup>
          <div class="title-desc"><span style="color:#ff0000">*</span>期望完成时间:</div>
          <input-pattern :check-list="checkList" :index="6" class="addressText" :disabled="true" @click="timeShow=true"></input-pattern>
          <van-popup v-model="timeShow" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="datetime"
              title="选择时间"
              :min-date="minDate"
              :max-date="maxDate"
              :formatter="formatter"
              @cancel="timeShow = false"
              @confirm="confirmTimePicker"
            />
          </van-popup>
          <div class="title-desc"><span style="color:#ff0000">*</span>报修人:</div>
          <input-pattern :check-list="checkList" :index="0"></input-pattern>
          <div class="title-desc"><span style="color:#ff0000">*</span>联系电话:</div>
          <div class="block">
            <div class="top">
              <input-pattern :check-list="checkList" class="inputPattern" :index="1"></input-pattern>
              <van-button type="primary" class="btn" :disabled="btnDisabled" @click="sendCode">{{ btnText }}</van-button>
            </div>
            <div v-show="codeShow" class="title-desc">验证码:</div>
            <van-field v-show="codeShow" v-model="codeValue" placeholder="请输入验证码" />
          </div>

          <div class="title-desc"><span style="color:#ff0000">*</span>故障描述:</div>
          <input-pattern :check-list="checkList" :index="4"></input-pattern>

          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit" @click="handleCommit">提交报修</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { Dialog } from 'vant'
import InputPattern from './components/InputPattern.vue'
import { listProject } from '@/api/user/index.js'

export default {
  name: 'AppRepairApplication',
  components: { InputPattern, [Dialog.Component.name]: Dialog.Component },
  data() {
    return {
      width: '0',
      height: '0',
      value: '',
      codeValue: '',
      codeShow: false,
      time: 60,
      btnText: '发送验证码',
      btnDisabled: false,
      showPicker: false,
      columns: [],
      form: {
        name: '',
        phone: '',
        address: '',
        detailAddress: ''
      },
      phoneTimer: null,
      phoneTimer1: null,
      projectShow: false,
      timeValue: '请选择时间',
      timeShow: false,
      minDate: '',
      maxDate: '',
      currentDate: new Date(),
      projectList: [],
      projectNeedList: [],
      projectNeedInf: {},
      projectNeedName: [],
      checkList: [
        {
          rule: /\S/,
          value: '',
          msg: '',
          state: false,
          type: 'text',
          des: '姓名不能为空',
          placeHolder: '请输入姓名'
        }, {
          rule: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
          value: '',
          msg: '',
          state: false,
          type: 'text',
          des: '请输入正确的手机号',
          placeHolder: '请输入手机号'
        },
        {
          rule: /\S/,
          value: '',
          msg: '',
          state: false,
          type: 'text',
          des: '地区不能为空',
          placeHolder: '请选择地区'
        },
        {
          rule: /\S/,
          value: '',
          msg: '',
          state: true,
          type: 'text',
          des: '',
          placeHolder: '请输入您的地址'
        }, {
          rule: /\S/,
          value: '',
          msg: '',
          state: false,
          type: 'textarea',
          des: '故障描述不能为空',
          placeHolder: '请输入故障描述'
        }, {
          rule: /\S/,
          value: '',
          msg: '',
          state: false,
          type: 'text',
          des: '标题不能为空',
          placeHolder: '请输入标题'
        }, {
          rule: /\S/,
          value: '',
          msg: '',
          state: false,
          type: 'text',
          des: '时间不能为空',
          placeHolder: '请选择时间'
        }, {
          rule: /\S/,
          value: '',
          msg: '',
          state: false,
          type: 'text',
          des: '项目名称不能为空',
          placeHolder: '请选择项目'
        }
      ],
      queryId: ''
    }
  },
  created() {
    const times = new Date()
    this.minDate = new Date(times.getFullYear(), times.getMonth(), times.getDate(), times.getHours(), times.getMinutes())
    this.maxDate = new Date(times.getFullYear() + 1, times.getMonth(), times.getDate(), times.getHours(), times.getMinutes())
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id
    }
    this.getAreaList()
    this.getProjectList()
    this.getBrowserInterfaceSize()
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.phoneTimer !== null) {
      clearInterval(this.phoneTimer)
      this.phoneTimer = null
    }
    if (this.phoneTimer1 !== null) {
      clearInterval(this.phoneTimer1)
      this.phoneTimer1 = null
    }
  },
  methods: {
    /*
    * sendCode 验证码功能
    * checkProject     检查项目列表
    * getProjectList   获取项目列表
    * getAreaList       获取区域列表
    */
    getBrowserInterfaceSize() {
      var pageWidth = window.innerWidth
      var pageHeight = window.innerHeight
      if (typeof pageWidth !== 'number') {
        // 在标准模式下面
        if (document.compatMode === 'CSS1Compat') {
          pageWidth = document.documentElement.clientWidth
          pageHeight = document.documentElement.clientHeight
        } else {
          pageWidth = document.body.clientWidth
          pageHeight = window.body.clientHeight
        }
      }
      this.width = pageWidth + 'px'
      this.height = pageHeight + 'px'
      console.log(this.width, this.height)
    },
    sendCode() {
      const temp = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (temp.test(this.checkList[1].value)) {
        this.codeShow = true
        this.btnText = ''
        this.btnDisabled = true
        this.time = 59
        this.btnText = this.time + 's'
        this.$axios.get(this.ip + `/oa/sms-code/${this.checkList[1].value}`).then(res => {
          console.log(res)
        })
        this.phoneTimer = setInterval(() => {
          this.time -= 1
          this.btnText = this.time + 's'
        }, 1000)

        this.phoneTimer1 = setTimeout(() => {
          this.btnText = '发送验证码'
          this.time = 61
          this.btnDisabled = false
          clearInterval(this.phoneTimer)
        }, 60000)
      } else {
        Toast.fail('请输入正确的手机号')
      }
    },
    checkProject() {
      this.projectNeedInf = {}
      this.filterArea()
      this.projectShow = true
    },
    filterArea() {
      this.projectNeedList = this.projectList.filter((value) => {
        return value.projectName.indexOf(this.checkList[7].value) > -1
      })
      const temp = []
      this.projectNeedList.forEach((item) => {
        temp.push(item.projectName)
      })
      this.projectNeedName = temp
    },
    async getProjectList() {
      const params = {
        limit: 10,
        page: 1,
        projectUser: '',
        projectName: '',
        projectId: this.queryId
      }
      const res = await listProject(params)
      this.projectNeedInf = res.data.list[0]
      console.log(this.projectNeedInf)
      this.checkList[7].value = this.projectNeedInf.projectName
      this.checkList[2].value = this.projectNeedInf.projectAddress

      // this.projectList = res.data.list[0]
      // this.$axios.get(this.ip + '/oa/listProject').then(response => {
      //   const res = response.data
      //   if (res.code === 0) {
      //     this.projectList = res.data
      //     console.log(this.projectList)
      //   }
      // })
    },
    getAreaList() {
      this.$axios.get(this.ip + '/oa/listArea').then(response => {
        const res = response.data
        if (res.code === 0) {
          res.data.forEach((el) => {
            el.children.forEach(ele => {
              ele.text = ele.area_name
              ele.value = ele.area_id
            })
            this.columns.push({
              text: el.area_name,
              value: el.area_id,
              children: el.children
            })
          })
        }
      })
    },
    hasProject(inf) {
      for (const i in this.projectList) {
        if (inf === this.projectList[i].projectName) {
          return true
        }
      }
      return false
    },
    handleCommit() {
      const _this = this
      _this.form = {
        reporter: _this.checkList[0].value,
        reporterMobile: _this.checkList[1].value,
        reportAddress: _this.checkList[2].value,
        reportProblem: _this.checkList[4].value,
        devName: '',
        captcha: _this.codeValue,
        subject: _this.checkList[5].value,
        requireMaintenanceTime: _this.checkList[6].value,
        maintenanceName: _this.projectNeedInf.maintenanceName,
        maintenanceId: _this.projectNeedInf.maintenanceId,
        maintenanceMobile: _this.projectNeedInf.maintenanceMobile,
        projectAddress: _this.projectNeedInf.projectAddress,
        projectName: _this.checkList[7].value,
        projectMobile: _this.projectNeedInf.projectMobile,
        maintenanceType: _this.projectNeedInf.maintenanceType,
        customerName: _this.projectNeedInf.customerName,
        projectUser: _this.projectNeedInf.projectUser
      }
      if (_this.form.reporter === '') {
        _this.checkList[0].state = true
      } else if (_this.form.reporterMobile === '') {
        _this.checkList[1].state = true
      } else if (_this.form.projectAddress === '') {
        _this.checkList[2].state = true
      } else if (_this.form.reportProblem === '') {
        _this.checkList[4].state = true
      } else if (_this.form.subject === '') {
        _this.checkList[5].state = true
      } else if (_this.form.requireMaintenanceTime === '') {
        _this.checkList[6].state = true
      } else if (_this.form.projectName === '') {
        _this.checkList[7].state = true
      } else {
        _this.$axios({
          url: _this.ip + '/oa/report-apply',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(_this.form)
        }).then(response => {
          const res = response.data
          if (res.code === 0) {
            _this.$router.push('/appRepairApplication/success?type=success')
          } else {
            Toast.fail(res.msg)
          }
          _this.checkList.forEach(el => {
            el.state = false
          })
        })
      }

      //  else if (!_this.hasProject(_this.form.projectName)) {
      //   Dialog.alert({
      //     message: '无此项目名称'
      //   }).then(() => {
      //     // on close
      //   })
      // }
      // _this.$router.push('/appRepairApplication/success?type=success')
    },
    cancelPicker() {
      this.showPicker = false
    },
    confirmPicker(e) {
      this.showPicker = false
      this.$refs.vanPickers.getValues()
      this.checkList[2].value = e.join('')
    },
    onClickLeft() {
      this.$router.push('/appRepair?id=' + this.queryId)
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo)
    },
    // 显示弹窗
    showPopup() {
      this.show = true
      this.isLoadingShow = true
      setTimeout(() => {
        this.isLoadingShow = false
      }, 500)
    },
    // 确认选择的时间
    confirmTimePicker(val) {
      const year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      let hour = val.getHours()
      let minute = val.getMinutes()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
      if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
      this.className = 'timeClass'
      this.checkList[6].value = `${year}-${month}-${day} ${hour}:${minute}` + ':00'
      this.timeShow = false
    },
    // 选项格式化函数
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      } else if (type === 'hour') {
        return `${value}时`
      } else if (type === 'minute') {
        return `${value}分`
      } else if (type === 'second') {
        return `${value}秒`
      }
      return value
    },
    projectConfirm(val, index) {
      console.log(this.projectNeedList[index].projectAddress)
      this.projectNeedInf = this.projectNeedList[index]
      this.checkList[7].value = val
      this.projectShow = false
    }
  }
}
</script>

<style scoped lang='scss'>
.appRepairApplication{
  ::v-deep .van-field__control{
    font-size: 15px!important;
  }
  .popUp{
    width:80%;
    height:30%;
    padding: 1.25rem;
  }
  .block{
    .top{
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .inputPattern{
        width: 65%;
      }
    }
  }

  ::v-deep .btn{
    margin-top: .625rem;
    width: 6.55rem;
    height: 1.7rem;
    border-radius: .3125rem;
    font-size: .75rem;
  }
  ::v-deep .addressText{
    .van-field__control{
      color: #aaa!important;
      opacity: 1!important;
    }
  }

  .content{
    padding:1.125rem .625rem 0;
    .img1{
      width: .9375rem;
      height: .875rem;
    }
    .form{
      margin-top: .625rem;
      padding: 1.3125rem;
      border-radius: .625rem;
      background-color: #fff;
      .item{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .inputPattern{
          width:65%
        }

      }
    }
    .title-desc{
      font-size: .8125rem;
      width: 6.25rem;
      color: #000000;
      font-family: '黑体';
      letter-spacing: .0625rem;
      line-height: 1.3125rem;
    }
  }
}

</style>
